// Периоды выгрузки: чистые функции без обращения к серверу

export type PeriodPreset = 'all' | 'today' | 'week' | 'month' | 'prevMonth' | 'custom';

export const PERIOD_PRESETS: Array<{ value: PeriodPreset; label: string }> = [
  { value: 'all', label: 'За всё время' },
  { value: 'today', label: 'Сегодня' },
  { value: 'week', label: 'За последние 7 дней' },
  { value: 'month', label: 'Текущий месяц' },
  { value: 'prevMonth', label: 'Прошлый месяц' },
  { value: 'custom', label: 'Свой период…' }
];

/** Дата в локальном часовом поясе как yyyy-mm-dd (toISOString сдвигал бы день для UTC+5) */
export function ymd(d: Date): string {
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
}

/** Границы периода для пресета; для «своего» периода и «за всё время» возвращает null - даты задаёт пользователь */
export function periodRange(preset: PeriodPreset, now: Date = new Date()): { from: string; to: string } | null {
  switch (preset) {
    case 'today':
      return { from: ymd(now), to: ymd(now) };
    case 'week': {
      const weekAgo = new Date(now.getFullYear(), now.getMonth(), now.getDate() - 7);
      return { from: ymd(weekAgo), to: ymd(now) };
    }
    case 'month':
      return { from: ymd(new Date(now.getFullYear(), now.getMonth(), 1)), to: ymd(now) };
    case 'prevMonth':
      return {
        from: ymd(new Date(now.getFullYear(), now.getMonth() - 1, 1)),
        to: ymd(new Date(now.getFullYear(), now.getMonth(), 0))
      };
    default:
      return null;
  }
}
